/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { User } from './User'
import { UserFromJSON, UserFromJSONTyped, UserToJSON } from './User'

/**
 *
 * @export
 * @interface Registration200ResponseData
 */
export interface Registration200ResponseData {
  /**
   *
   * @type {User}
   * @memberof Registration200ResponseData
   */
  user: User
}

/**
 * Check if a given object implements the Registration200ResponseData interface.
 */
export function instanceOfRegistration200ResponseData(
  value: object
): value is Registration200ResponseData {
  if (!('user' in value) || value['user'] === undefined) return false
  return true
}

export function Registration200ResponseDataFromJSON(
  json: any
): Registration200ResponseData {
  return Registration200ResponseDataFromJSONTyped(json, false)
}

export function Registration200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Registration200ResponseData {
  if (json == null) {
    return json
  }
  return {
    user: UserFromJSON(json['user']),
  }
}

export function Registration200ResponseDataToJSON(
  value?: Registration200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    user: UserToJSON(value['user']),
  }
}
